module.exports = __webpack_public_path__ + "static/media/followthefood_logo.f0781533.svg";